import { type StatusConfig, TONE_CLASSES, type Tone } from "@/lib/status";
import { cn } from "@/lib/utils";

/**
 * The one way statuses are rendered. Label, tone and icon come from src/lib/status; screens never
 * invent colors for raw status strings.
 */
export function StatusBadge({
  config,
  className,
  dot = false,
  pulse = false,
  title,
}: {
  config: StatusConfig;
  className?: string;
  /** Dot instead of icon (dense tables). */
  dot?: boolean;
  pulse?: boolean;
  title?: string;
}) {
  const tone = TONE_CLASSES[config.tone];
  const Icon = config.icon;
  return (
    <span
      title={title ?? config.description}
      className={cn("inline-flex h-5 shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 font-medium text-xs", tone.bg, tone.text, className)}
    >
      {dot || !Icon ? (
        <span aria-hidden className={cn("size-1.5 rounded-full", tone.dot, pulse && "animate-pulse-dot")} />
      ) : (
        <Icon aria-hidden className={cn("size-3", pulse && "animate-pulse-dot")} />
      )}
      {config.label}
    </span>
  );
}

export function ToneDot({ tone, pulse, className }: { tone: Tone; pulse?: boolean; className?: string }) {
  return <span aria-hidden className={cn("inline-block size-2 shrink-0 rounded-full", TONE_CLASSES[tone].dot, pulse && "animate-pulse-dot", className)} />;
}
